// React context for the screen-level runtime (TxnScreenRuntime). <TxnScreen>
// provides it; nested shared components that need the screen transport
// (ChildFormTab's item_change / lazy child loads / validate) read it via
// useTxnScreenRuntime(). Host apps that mount ChildFormTab OUTSIDE a
// TxnScreen (e.g. the platform's approvals inbox) wrap it in this provider
// themselves.

import { createContext, useContext } from 'react'
import type { ReactNode } from 'react'
import type { TxnScreenRuntime } from './contract'

const TxnScreenRuntimeContext = createContext<TxnScreenRuntime | null>(null)

export function TxnScreenRuntimeProvider(
  { value, children }: { value: TxnScreenRuntime; children: ReactNode },
) {
  return (
    <TxnScreenRuntimeContext.Provider value={value}>
      {children}
    </TxnScreenRuntimeContext.Provider>
  )
}

export function useTxnScreenRuntime(): TxnScreenRuntime {
  const ctx = useContext(TxnScreenRuntimeContext)
  if (!ctx) {
    throw new Error(
      'useTxnScreenRuntime must be used within a <TxnScreenRuntimeProvider>. '
      + 'The shared transaction screen components need a host-provided '
      + 'transport.',
    )
  }
  return ctx
}
